// extracted by mini-css-extract-plugin
export var hidden = "_te-0";